import axios from 'axios'
import router from '../router'
import { getTokenSyn } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API + '/?s=', // api的base_url
  timeout: 15000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  // 10003
  response => {
    /**
     * code 10003 未登录 跳转登录
     */
    const res = response.data
    if (res.errorcode === 10003) {
      router.replace({path: '/login'})
      localStorage.setItem('accountIsLogin', false)
      return response
    }
    if (res.errorcode === 10002) {
      // token 过期 或者 token存储失败
      // this.$vux.toast.hide()
      response.data.errormsg = 'loading...'
      router.go(0)
      return response
    }
    return response
  },
  // response => response,
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js